import * as React from 'react'

export type LocaleIconPlaceholderProps = React.SVGProps<SVGSVGElement> & {
  /** 展开/激活态时描边为主题色 */
  $show?: boolean
}

/**
 * 多语言入口图标占位 — 与 Figma 对齐后可替换为导出的正式 SVG。
 * 尺寸 16×16，描边与 DownArrowIcon 一致 #64748B。
 */
export const LocaleIconPlaceholder = ({ $show, ...svgProps }: LocaleIconPlaceholderProps) => {
  const stroke = $show ? '#f3512b' : '#64748B'
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
      className={'header-locale-icon'}
    >
      <path
        d='M9.9974 18.3346C14.5998 18.3346 18.3307 14.6037 18.3307 10.0013C18.3307 5.39893 14.5998 1.66797 9.9974 1.66797C5.39502 1.66797 1.66406 5.39893 1.66406 10.0013C1.66406 14.6037 5.39502 18.3346 9.9974 18.3346Z'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.9974 1.66797C7.85759 3.91476 6.66406 6.89859 6.66406 10.0013C6.66406 13.104 7.85759 16.0878 9.9974 18.3346C12.1372 16.0878 13.3307 13.104 13.3307 10.0013C13.3307 6.89859 12.1372 3.91476 9.9974 1.66797Z'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M1.66406 10H18.3307' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}
